// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.dashboard-page {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;
  color: var(--ca-text-primary, #172033);
}

.dashboard-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0.25rem 0 2rem;
}

.dashboard-heading-copy {
  min-width: 0;
}

.dashboard-eyebrow {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.55rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.eyebrow-mark {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 2px;
  background: var(--ca-primary-light, #2850ad);
  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);
}

.dashboard-heading h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.65rem, 2.4vw, 2.15rem);
  font-weight: 750;
  letter-spacing: -0.045em;
  line-height: 1.2;
}

.dashboard-subtitle {
  max-width: 740px;
  margin: 0.65rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.65;
}

.dashboard-context {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 0 0 auto;
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.context-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid #d8e3ff;
  border-radius: var(--ca-radius-md, 8px);
  background: #eef3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.05rem;
}

.dashboard-context > div {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.context-label {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.68rem;
  font-weight: 650;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.dashboard-context strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 700;
  white-space: nowrap;
}

.metrics-section {
  margin-bottom: 1.65rem;
}

.section-intro {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
}

.section-intro h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
  letter-spacing: -0.015em;
}

.section-intro p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.8rem;
}

.metrics-count,
.panel-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface, #fff);
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.7rem;
  font-weight: 650;
  white-space: nowrap;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.metric-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 200px;
  flex-direction: column;
  overflow: hidden;
  padding: 1.15rem 1.2rem 1.05rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  border-color: var(--ca-border, #dfe4ec);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.metric-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 1.1rem;
}

.metric-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  border-radius: 0.8rem;
  font-size: 1.1rem;
}

.metric-card--zones .metric-icon {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.metric-card--assets .metric-icon {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.metric-card--environments .metric-icon {
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.metric-card--risk .metric-icon {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.metric-status {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.28rem 0.5rem;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 700;
  white-space: nowrap;
}

.metric-status > span {
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 50%;
  background: currentColor;
}

.metric-status--success {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.metric-status--info {
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.metric-status--primary {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.metric-status--danger {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.metric-copy {
  min-width: 0;
}

.metric-copy h2 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 1rem;
  font-weight: 650;
  line-height: 1.4;
}

.metric-value {
  overflow: hidden;
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.75rem, 2vw, 2.15rem);
  font-weight: 750;
  letter-spacing: -0.05em;
  line-height: 1.2;
  text-overflow: ellipsis;
}

.metric-unit {
  margin-left: 0.15rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0;
}

.metric-description {
  margin: 0.45rem 0 0;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  line-height: 1.4;
}

.metric-description strong {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 750;
}

.metric-accent {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  opacity: 0.8;
}

.metric-card--zones .metric-accent {
  background: var(--ca-primary-light, #2850ad);
}

.metric-card--assets .metric-accent {
  background: var(--ca-success, #198754);
}

.metric-card--environments .metric-accent {
  background: var(--ca-info, #1d7fbf);
}

.metric-card--risk .metric-accent {
  background: var(--ca-danger, #dc3545);
}

.dashboard-panels {
  display: grid;
  grid-template-columns: minmax(0, 1.02fr) minmax(0, 1.18fr);
  gap: 1.15rem;
  align-items: stretch;
}

.dashboard-panel {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 1.15rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.panel-heading-copy {
  min-width: 0;
}

.panel-title-line {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.panel-title-line h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.98rem;
  font-weight: 750;
  line-height: 1.4;
}

.panel-heading-copy > p {
  margin: 0.45rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.76rem;
  line-height: 1.5;
}

.panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.15rem;
  height: 2.15rem;
  flex: 0 0 2.15rem;
  border-radius: 0.65rem;
  font-size: 0.95rem;
}

.panel-icon--chart {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.panel-icon--table {
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.panel-tag {
  margin-top: 0.1rem;
  background: var(--ca-bg, #f5f7fb);
}

.chart-content {
  position: relative;
  min-width: 0;
  height: 330px;
  padding-top: 1rem;
}

.chart-content canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}

.summary-table-content {
  min-width: 0;
  padding-top: 1rem;
}

.summary-table-content app-report-table {
  display: block;
  min-width: 0;
  width: 100%;
}

@media (max-width: 1200px) {
  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-panels {
    grid-template-columns: minmax(0, 1fr);
  }
  .chart-content {
    height: 320px;
  }
}
@media (max-width: 767.98px) {
  .dashboard-page {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .dashboard-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  .dashboard-context {
    width: 100%;
  }
  .section-intro {
    align-items: flex-start;
  }
  .metrics-count {
    display: none;
  }
  .metric-card {
    min-height: 185px;
    padding: 1rem;
  }
  .dashboard-panel {
    padding: 0.9rem;
  }
  .panel-header {
    align-items: flex-start;
  }
  .panel-tag {
    display: none;
  }
  .chart-content {
    height: 280px;
  }
}
@media (max-width: 480px) {
  .metrics-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .metric-card {
    min-height: auto;
  }
  .metric-topline {
    margin-bottom: 0.8rem;
  }
  .metric-value {
    font-size: 1.9rem;
  }
  .panel-title-line {
    align-items: flex-start;
  }
  .panel-title-line h2 {
    padding-top: 0.15rem;
  }
  .chart-content {
    height: 250px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .metric-card {
    transition: none;
  }
  .metric-card:hover {
    transform: none;
  }
}
/* Security-zone dashboard loading and empty states */
.dashboard-state {
  display: flex;
  min-height: 320px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  text-align: center;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.dashboard-state h2 {
  margin: 1rem 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
}

.dashboard-state p {
  max-width: 460px;
  margin: 0 0 1rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.85rem;
  line-height: 1.6;
}

.dashboard-loading-spinner {
  width: 2.35rem;
  height: 2.35rem;
  border: 3px solid var(--ca-border-light, #e9edf3);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: dashboard-spin 0.8s linear infinite;
}

.state-icon {
  display: inline-flex;
  width: 2.8rem;
  height: 2.8rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.85rem;
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
  font-size: 1.2rem;
}

.chart-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-empty-state {
  position: absolute;
  inset: 1rem 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.8rem;
  text-align: center;
  pointer-events: none;
}

.chart-empty-state i {
  font-size: 1.6rem;
}

.table-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.5rem 1rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.8rem;
  text-align: center;
}

.table-empty-state i {
  font-size: 1.05rem;
}

@keyframes dashboard-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .dashboard-loading-spinner {
    animation-duration: 2s;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/security-zone/authoring-tools/security-zone-dashboard/security-zone-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAGA;EACE,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAAF;AAEE;EACE,sCAAA;EACA,0BAAA;AAAJ;AAGE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AADJ;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EAEE,wCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAOA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;EACA,sCAAA;AAJF;;AAQA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AALF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,4CAAA;EACA,uDAAA;AALF;;AAQA;EACE,SAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,uCAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AALF;;AAQA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AALF;;AAQA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,sBAAA;AALF;;AAQA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AALF;;AAQA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AALF;;AAQA;EACE,mBAAA;EACA,uCAAA;EACA,iBAAA;AALF;;AAQA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,iDAAA;EACA,oBAAA;EACA,mCAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AALF;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;EACA,6EAAA;AALF;;AAQA;EACE,2BAAA;EACA,uCAAA;EACA,iEAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,qBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AALF;;AAQA;EACE,6CAAA;EACA,iCAAA;AALF;;AAQA;EACE,yCAAA;EACA,iCAAA;AALF;;AAQA;EACE,sCAAA;EACA,8BAAA;AALF;;AAQA;EACE,wCAAA;EACA,gCAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;AALF;;AAQA;EACE,yCAAA;EACA,iCAAA;AALF;;AAQA;EACE,sCAAA;EACA,8BAAA;AALF;;AAQA;EACE,6CAAA;EACA,iCAAA;AALF;;AAQA;EACE,wCAAA;EACA,gCAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,SAAA;EACA,sCAAA;EACA,uCAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;AALF;;AAQA;EACE,oBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AALF;;AAQA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,wCAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AALF;;AAQA;EACE,4CAAA;AALF;;AAQA;EACE,sCAAA;AALF;;AAQA;EACE,mCAAA;AALF;;AAQA;EACE,qCAAA;AALF;;AAQA;EACE,aAAA;EACA,0DAAA;EACA,YAAA;EACA,oBAAA;AALF;;AAQA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,wDAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AALF;;AAQA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AALF;;AAQA;EACE,6CAAA;EACA,iCAAA;AALF;;AAQA;EACE,sCAAA;EACA,8BAAA;AALF;;AAQA;EACE,kBAAA;EACA,iCAAA;AALF;;AAQA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AALF;;AAQA;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;AALF;;AAQA;EACE,YAAA;EACA,iBAAA;AALF;;AAQA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AALF;;AAQA;EACE;IACE,gDAAA;EALF;EAQA;IACE,qCAAA;EANF;EASA;IACE,aAAA;EAPF;AACF;AAUA;EACE;IACE,qBAAA;IACA,oBAAA;EARF;EAWA;IACE,uBAAA;IACA,sBAAA;IACA,SAAA;IACA,qBAAA;EATF;EAYA;IACE,WAAA;EAVF;EAaA;IACE,uBAAA;EAXF;EAcA;IACE,aAAA;EAZF;EAeA;IACE,iBAAA;IACA,aAAA;EAbF;EAgBA;IACE,eAAA;EAdF;EAiBA;IACE,uBAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;EAmBA;IACE,aAAA;EAjBF;AACF;AAoBA;EACE;IACE,qCAAA;EAlBF;EAqBA;IACE,gBAAA;EAnBF;EAsBA;IACE,qBAAA;EApBF;EAuBA;IACE,iBAAA;EArBF;EAwBA;IACE,uBAAA;EAtBF;EAyBA;IACE,oBAAA;EAvBF;EA0BA;IACE,aAAA;EAxBF;AACF;AA2BA;EACE;IACE,gBAAA;EAzBF;EA4BA;IACE,eAAA;EA1BF;AACF;AA8BA,qDAAA;AACA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AA5BF;;AA+BA;EACE,sBAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,eAAA;EACA,iDAAA;EACA,4CAAA;EACA,kBAAA;EACA,8CAAA;AA5BF;;AA+BA;EACE,oBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,wCAAA;EACA,gCAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AA5BF;;AA+BA;EACE,iBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,kBAAA;AA5BF;;AA+BA;EACE;IAAK,yBAAA;EA3BL;AACF;AA6BA;EACE;IACE,sBAAA;EA3BF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  \n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n\n.dashboard-page {\n  width: 100%;\n  max-width: 1600px;\n  margin: 0 auto;\n  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;\n  color: var(--ca-text-primary, #172033);\n}\n\n\n.dashboard-heading {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1.5rem;\n  margin: 0.25rem 0 2rem;\n}\n\n.dashboard-heading-copy {\n  min-width: 0;\n}\n\n.dashboard-eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 0.55rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n}\n\n.eyebrow-mark {\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 2px;\n  background: var(--ca-primary-light, #2850ad);\n  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);\n}\n\n.dashboard-heading h1 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.65rem, 2.4vw, 2.15rem);\n  font-weight: 750;\n  letter-spacing: -0.045em;\n  line-height: 1.2;\n}\n\n.dashboard-subtitle {\n  max-width: 740px;\n  margin: 0.65rem 0 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.65;\n}\n\n.dashboard-context {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 0 0 auto;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.context-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 1px solid #d8e3ff;\n  border-radius: var(--ca-radius-md, 8px);\n  background: #eef3ff;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.05rem;\n}\n\n.dashboard-context > div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.context-label {\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.68rem;\n  font-weight: 650;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.dashboard-context strong {\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.82rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.metrics-section {\n  margin-bottom: 1.65rem;\n}\n\n.section-intro {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 0.9rem;\n}\n\n.section-intro h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.05rem;\n  font-weight: 750;\n  letter-spacing: -0.015em;\n}\n\n.section-intro p {\n  margin: 0.25rem 0 0;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.8rem;\n}\n\n.metrics-count,\n.panel-tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 0.35rem 0.6rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 999px;\n  background: var(--ca-surface, #fff);\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.7rem;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.metric-card {\n  position: relative;\n  display: flex;\n  min-width: 0;\n  min-height: 200px;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 1.15rem 1.2rem 1.05rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.metric-card:hover {\n  transform: translateY(-2px);\n  border-color: var(--ca-border, #dfe4ec);\n  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\n}\n\n.metric-topline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n  margin-bottom: 1.1rem;\n}\n\n.metric-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.55rem;\n  height: 2.55rem;\n  flex: 0 0 2.55rem;\n  border-radius: 0.8rem;\n  font-size: 1.1rem;\n}\n\n.metric-card--zones .metric-icon {\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.metric-card--assets .metric-icon {\n  background: var(--ca-success-bg, #eaf7f0);\n  color: var(--ca-success, #198754);\n}\n\n.metric-card--environments .metric-icon {\n  background: var(--ca-info-bg, #eaf6fc);\n  color: var(--ca-info, #1d7fbf);\n}\n\n.metric-card--risk .metric-icon {\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n}\n\n.metric-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.28rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.66rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.metric-status > span {\n  width: 0.35rem;\n  height: 0.35rem;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.metric-status--success {\n  background: var(--ca-success-bg, #eaf7f0);\n  color: var(--ca-success, #198754);\n}\n\n.metric-status--info {\n  background: var(--ca-info-bg, #eaf6fc);\n  color: var(--ca-info, #1d7fbf);\n}\n\n.metric-status--primary {\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.metric-status--danger {\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n}\n\n.metric-copy {\n  min-width: 0;\n}\n\n.metric-copy h2 {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 1rem;\n  font-weight: 650;\n  line-height: 1.4;\n}\n\n.metric-value {\n  overflow: hidden;\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.75rem, 2vw, 2.15rem);\n  font-weight: 750;\n  letter-spacing: -0.05em;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n}\n\n.metric-unit {\n  margin-left: 0.15rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.95rem;\n  font-weight: 600;\n  letter-spacing: 0;\n}\n\n.metric-description {\n  margin: 0.45rem 0 0;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.72rem;\n  line-height: 1.4;\n}\n\n.metric-description strong {\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 750;\n}\n\n.metric-accent {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  opacity: 0.8;\n}\n\n.metric-card--zones .metric-accent {\n  background: var(--ca-primary-light, #2850ad);\n}\n\n.metric-card--assets .metric-accent {\n  background: var(--ca-success, #198754);\n}\n\n.metric-card--environments .metric-accent {\n  background: var(--ca-info, #1d7fbf);\n}\n\n.metric-card--risk .metric-accent {\n  background: var(--ca-danger, #dc3545);\n}\n\n.dashboard-panels {\n  display: grid;\n  grid-template-columns: minmax(0, 1.02fr) minmax(0, 1.18fr);\n  gap: 1.15rem;\n  align-items: stretch;\n}\n\n.dashboard-panel {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  padding: 1.15rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.panel-heading-copy {\n  min-width: 0;\n}\n\n.panel-title-line {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.panel-title-line h2 {\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.98rem;\n  font-weight: 750;\n  line-height: 1.4;\n}\n\n.panel-heading-copy > p {\n  margin: 0.45rem 0 0;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.76rem;\n  line-height: 1.5;\n}\n\n.panel-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.15rem;\n  height: 2.15rem;\n  flex: 0 0 2.15rem;\n  border-radius: 0.65rem;\n  font-size: 0.95rem;\n}\n\n.panel-icon--chart {\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.panel-icon--table {\n  background: var(--ca-info-bg, #eaf6fc);\n  color: var(--ca-info, #1d7fbf);\n}\n\n.panel-tag {\n  margin-top: 0.1rem;\n  background: var(--ca-bg, #f5f7fb);\n}\n\n.chart-content {\n  position: relative;\n  min-width: 0;\n  height: 330px;\n  padding-top: 1rem;\n}\n\n.chart-content canvas {\n  display: block;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.summary-table-content {\n  min-width: 0;\n  padding-top: 1rem;\n}\n\n.summary-table-content app-report-table {\n  display: block;\n  min-width: 0;\n  width: 100%;\n}\n\n@media (max-width: 1200px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .dashboard-panels {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .chart-content {\n    height: 320px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .dashboard-page {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n\n  .dashboard-heading {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .dashboard-context {\n    width: 100%;\n  }\n\n  .section-intro {\n    align-items: flex-start;\n  }\n\n  .metrics-count {\n    display: none;\n  }\n\n  .metric-card {\n    min-height: 185px;\n    padding: 1rem;\n  }\n\n  .dashboard-panel {\n    padding: 0.9rem;\n  }\n\n  .panel-header {\n    align-items: flex-start;\n  }\n\n  .panel-tag {\n    display: none;\n  }\n\n  .chart-content {\n    height: 280px;\n  }\n}\n\n@media (max-width: 480px) {\n  .metrics-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .metric-card {\n    min-height: auto;\n  }\n\n  .metric-topline {\n    margin-bottom: 0.8rem;\n  }\n\n  .metric-value {\n    font-size: 1.9rem;\n  }\n\n  .panel-title-line {\n    align-items: flex-start;\n  }\n\n  .panel-title-line h2 {\n    padding-top: 0.15rem;\n  }\n\n  .chart-content {\n    height: 250px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .metric-card {\n    transition: none;\n  }\n\n  .metric-card:hover {\n    transform: none;\n  }\n}\n\n\n/* Security-zone dashboard loading and empty states */\n.dashboard-state {\n  display: flex;\n  min-height: 320px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1.25rem;\n  text-align: center;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.dashboard-state h2 {\n  margin: 1rem 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.05rem;\n  font-weight: 750;\n}\n\n.dashboard-state p {\n  max-width: 460px;\n  margin: 0 0 1rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.85rem;\n  line-height: 1.6;\n}\n\n.dashboard-loading-spinner {\n  width: 2.35rem;\n  height: 2.35rem;\n  border: 3px solid var(--ca-border-light, #e9edf3);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: dashboard-spin 0.8s linear infinite;\n}\n\n.state-icon {\n  display: inline-flex;\n  width: 2.8rem;\n  height: 2.8rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.85rem;\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-danger, #dc3545);\n  font-size: 1.2rem;\n}\n\n.chart-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chart-empty-state {\n  position: absolute;\n  inset: 1rem 0 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.8rem;\n  text-align: center;\n  pointer-events: none;\n}\n\n.chart-empty-state i {\n  font-size: 1.6rem;\n}\n\n.table-empty-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1.5rem 1rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n.table-empty-state i {\n  font-size: 1.05rem;\n}\n\n@keyframes dashboard-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .dashboard-loading-spinner {\n    animation-duration: 2s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
